import classNames from "classnames";
import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import * as React from "react";
import { GetImmediateChildrenAsync } from "source/app/services/Workflows/GetImmediateChildren";
import Render from "source/app/presentation/Shared/Render";
import {
    SetSortSourceIcon,
    SetSortTarget,
} from "source/app/presentation/MainPanel/Workflows/RootNodeName/WorkflowsFloatingTools/SortNodes/SortNodes";
import { ChildNodeName } from "source/app/presentation/MainPanel/Workflows/RenderChildNodes/ChildNodeName/ChildNodeName";
import { IRenderChildNodesOptions } from "source/app/presentation/MainPanel/Workflows/RenderChildNodes/IRenderChildNodesOptions";
import { NodeModifiedTime } from "source/app/presentation/MainPanel/Workflows/RenderChildNodes/ModifiedTime/NodeModifiedTime";
import * as styles from "source/app/presentation/MainPanel/Workflows/RenderChildNodes/RenderChildNodes.css";
import { RenderChildNodes } from "source/app/presentation/MainPanel/Workflows/RenderChildNodes/RenderChildNodes";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { NodeBullet } from "source/app/presentation/MainPanel/Workflows/RenderChildNodes/Single/NodeBullet/NodeBullet";
import { LockedNodeIcon } from "source/app/presentation/MainPanel/Workflows/RenderChildNodes/Single/LockedNode/LockedNodeIcon";
import { WorkflowNodeSelectToggle } from "source/app/presentation/MainPanel/Workflows/RenderChildNodes/ChildNodeName/WorkflowNodeSelectToggle";

export const RenderChildNode = (
    props: IRenderChildNodesOptions & { node: IWorkflowNode }
) => {
    const {
        node,
        visibleNodes,
        rootNode,
        level,
        setRootNodeId,
        quizMode,
        sortMode,
        sortSource,
        randomNode,
        scrambledNode,
        index,
    } = props;
    const [immediateChildren, setimmediateChildren] = React.useState<
        IWorkflowNode[]
    >([]);

    React.useEffect(() => {
        let isCurrent = true;

        GetImmediateChildrenAsync(node, visibleNodes).then((nodes) => {
            if (isCurrent) {
                setimmediateChildren(nodes);
            }
        });

        return () => {
            isCurrent = false;
        };
    }, [node, visibleNodes]);

    const isMultiSelectEnabled = props.isMultiSelectMode;
    const isSelected = props.selectedNodeIds.includes(node.id);

    return (
        <Render id="node" when={node.parentid === rootNode.id}>
            <SetSortTarget
                sourceNode={sortSource}
                rootNode={rootNode}
                beforeNode={node}
                sortMode={sortMode}
                renderLevel={level}
            />
            <div
                data-workflow-node
                style={{ marginLeft: `${15 * level}px` }}
                className={classNames({
                    [styles.sortSource]: node.id === sortSource.id && sortMode,
                })}
            >
                <div
                    className={StyleClass(`renderChildNode_row_${isMultiSelectEnabled}`, {
                        display: `grid`,
                        gridTemplateColumns: isMultiSelectEnabled
                            ? `17px max-content 52px`
                            : `17px 1fr`,
                        alignItems: `start`,
                        marginBottom: `4px`,
                    })}
                >
                    <NodeBullet {...{ node, index }} />
                    <div
                        className={StyleClass(`renderChildNode_grid_Right`, {
                            paddingLeft: `8px`,
                            paddingTop: `3px`,
                        })}
                    >
                        <ChildNodeName
                            {...props}
                            node={node}
                            children={immediateChildren}
                            randomNode={randomNode}
                            scrambledNode={scrambledNode}
                            limitNameDisplayLength={
                                rootNode.options?.abbreviate ?? false
                            }
                        />
                        <NodeModifiedTime parentNode={rootNode} node={node} />
                        <SetSortSourceIcon
                            sortMode={props.sortMode}
                            node={node}
                        />
                        <LockedNodeIcon node={node} />
                        <Render
                            id="childNodes"
                            when={
                                immediateChildren.length > 0 &&
                                !node.iscollapsed
                            }
                        >
                            <RenderChildNodes
                                setRootNodeId={setRootNodeId}
                                visibleNodes={visibleNodes}
                                rootNode={node}
                                level={level + 1}
                                quizMode={quizMode}
                                sortMode={sortMode}
                                sortSource={sortSource}
                                randomNode={randomNode}
                                scrambledNode={scrambledNode}
                                index={index}
                                isMultiSelectMode={props.isMultiSelectMode}
                                selectedNodeIds={props.selectedNodeIds}
                            />
                        </Render>
                    </div>
                    <WorkflowNodeSelectToggle
                        node={node}
                        isMultiSelectEnabled={isMultiSelectEnabled}
                        isSelected={isSelected}
                    />
                </div>
            </div>
        </Render>
    );
};
